module.exports = __webpack_public_path__ + "img/134.5.14acf441.png";